import { createThunkRequest, DELETE, GET, POST } from '@webapp/account/src/libs/request';

import { API_URL_CORE_V1 } from '@webapp/common/conf';
import { getUserToken } from '@webapp/common/lib/cookies';
import { getFormattedParams } from '@webapp/common/lib/fetch';

export const getAllLanguages = createThunkRequest(
    'survey/getAllLanguages',
    () => {
        return GET('get/languages');
    },
    { notify: false },
);

export const getSurveyLanguages = createThunkRequest(
    'survey/getSurveyLanguages',
    ({ surveyId }: { surveyId: number }) => {
        return GET('get/languages_survey', { surveyId });
    },
    { notify: false },
);

export const downloadSurveyTranslationFile = async (params: { surveyId: number; lang: string }) => {
    const token = getUserToken();
    const url = `${API_URL_CORE_V1}/download/survey_translation${getFormattedParams(params)}`;

    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'T-Authorization': token || '',
        },
    });

    if (!response.ok) {
        throw new Error('Failed to download file');
    }

    // Получаем имя файла из заголовка Content-Disposition
    const contentDisposition = response.headers.get('content-disposition');
    let filename = 'translations.csv';
    if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (filenameMatch && filenameMatch[1]) {
            filename = filenameMatch[1].replace(/['"]/g, '');
        }
    }

    // Получаем текст ответа (CSV формат)
    const csvText = await response.text();

    // Добавляем BOM для корректного отображения UTF-8 в Excel
    const bom = '\uFEFF';
    const csvWithBom = bom + csvText;

    // Создаем blob с MIME-типом для CSV
    const blob = new Blob([csvWithBom], {
        type: 'text/csv;charset=utf-8',
    });

    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(downloadUrl);

    return response;
};

export const addSurveyTranslation = createThunkRequest(
    'survey/addSurveyTranslation',
    async (data: { surveyId: number; langs: string }) => {
        return await POST(`add/survey_translation`, data);
    },
);

export const uploadSurveyTranslationFile = createThunkRequest(
    'survey/uploadSurveyTranslationFile',
    async (data: { surveyId: number; lang: string; translate: any }) => {
        return await POST('upload/survey_translation', data);
    },
);

export const deleteSurveyTranslation = createThunkRequest(
    'survey/deleteSurveyTranslation',
    async ({ surveyId, lang }: { surveyId: number; lang: string }) => {
        return await DELETE(`delete/survey_translation/${surveyId}?lang=${lang}`);
    },
);

export const setDefaultSurveyLang = createThunkRequest(
    'survey/setDefaultSurveyLang',
    async (data: { surveyId: number; lang: string }) => {
        return await POST('set/survey_default_language', data);
    },
);
